module.exports = __webpack_public_path__ + "static/media/whatsappBackgroundImage.b93a2b2b.jpeg";